import version from '../version';

export default {
  computed: {
    app_version() {
      return version;
    }
  }
}